import { render, staticRenderFns } from "./filters-comp.vue?vue&type=template&id=33eca4e8&scoped=true"
import script from "./filters-comp.vue?vue&type=script&lang=js"
export * from "./filters-comp.vue?vue&type=script&lang=js"
import style0 from "./filters-comp.vue?vue&type=style&index=0&id=33eca4e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33eca4e8",
  null
  
)

export default component.exports